"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switcher = void 0;
var react_1 = __importDefault(require("react"));
var Switcher_styled_1 = require("./Switcher.styled");
var Switcher = function (_a) {
    var children = _a.children, threshold = _a.threshold, _b = _a.space, space = _b === void 0 ? 4 : _b, _c = _a.element, Element = _c === void 0 ? 'div' : _c;
    return (react_1.default.createElement(Switcher_styled_1.StyledSwitcher, { threshold: threshold, space: space },
        react_1.default.createElement(Element, null, children)));
};
exports.Switcher = Switcher;
